import type { State } from '../../common/types.tsx';

export const getReturnFocusTo = (state: State) => state.returnFocusTo;
